module.exports = __webpack_public_path__ + "img/18.8bbb25c7.jpg";